import React from "react";
import { observer } from "mobx-react";
import { Divider, Stack } from "@chakra-ui/react";
import { translations } from "@/constants/translations";
import { useStore } from "@/store";
import { OrderConfirmedPanel } from "../Confirm/OrderConfirmedPanel";
import { H2, H3 } from "@/components/Heading";
import { useEffectOnce } from "usehooks-ts";
import { telemetry } from "@/telemetry";

export const OrderRequestPage = observer(() => {
  const {
    activeLanguage,
    orderData,
    orderValidatedData,
    orderCreatedData,
    orderTotals,
  } = useStore();
  const language = translations.pages["order-confirm"][activeLanguage];

  useEffectOnce(() =>
    telemetry.trackEvent("order_request_viewed", {
      order_id: orderCreatedData?.orderId,
      total: orderTotals.total,
    }),
  );

  return (
    <OrderConfirmedPanel>
      <Stack
        spacing="14"
        alignItems="center"
        textAlign="center"
      >
        <H2>{language.thank_order_request}</H2>
        <Stack spacing="8">
          <Stack>
            <H3>{language.order_confirmation}</H3>
            <H3 color="primary-light">{orderValidatedData?.orderId}</H3>
          </Stack>
          <Stack>
            <H3>{language.a_member_emeergent_email}</H3>
            <H3 color="primary-light">{orderData.emailAddress}</H3>
          </Stack>
        </Stack>
        <Divider />
      </Stack>
    </OrderConfirmedPanel>
  );
});
